import React from 'react';
import { GenericImage } from '../generic-image';
export const ItemImage = ({ item, spaceForColumn }) => {
    let imageUrl = item.imageUrl;
    if (!imageUrl) {
        return null;
    }
    imageUrl = cropImageToSquare(imageUrl, spaceForColumn);
    return (React.createElement(GenericImage, { src: imageUrl, href: item.ctaUrl, alt: item.imageAltText, showAfterLoad: true }));
};
const FIT_REGEX = /fit\/w_(\d+),h_(\d+)/;
export function cropImageToSquare(imageUrl, maxImageWidth) {
    const match = imageUrl.match(FIT_REGEX);
    // NOTE: do not crop image in any way if it is cropped already
    if (match && !imageUrl.match(/crop\//)) {
        let width = parseInt(match[1], 10);
        let height = parseInt(match[2], 10);
        if (height > width) {
            height = Math.round((maxImageWidth * height) / width);
            width = maxImageWidth;
        }
        else {
            width = Math.round((maxImageWidth * width) / height);
            height = maxImageWidth;
        }
        const edge = Math.min(width, height);
        const x = Math.floor((width - edge) / 2);
        const y = Math.floor((height - edge) / 2);
        imageUrl = imageUrl.replace(FIT_REGEX, `fit/w_${width},h_${height}`);
        imageUrl = imageUrl.replace(/\/file\.([a-z]+)$/, `/crop/x_${x},y_${y},w_${edge},h_${edge}/file.$1`);
    }
    return imageUrl;
}
//# sourceMappingURL=item-image.js.map